import { FormatDecimals } from 'utils/Formatters'

const RangeSlider = {
  el: {
    sliders: document.querySelectorAll('.input-group--range'),
  },
  init() {
    if (this.el.sliders.length > 0) {
      Array.prototype.forEach.call(this.el.sliders, item => {
        const input = item.querySelector('input')
        const valueText = item.querySelector('.input-range__value')

        input.addEventListener('input', e => {
          const multiplier = input.getAttribute('data-multiplier')

          if (!multiplier) {
            this.updateValueText(valueText, e.target.value)
          }
          else {
            this.updateValueText(valueText, parseInt(e.target.value) * parseInt(multiplier))
          }
        })
      })
    }
  },
  updateValueText(target, value) {
    target.innerHTML = (value <= 0 ? 0 : FormatDecimals(parseInt(value)))
  },
}

export default RangeSlider
